import './applicationCard.scss';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';

import VehicleImagePlaceholder from '../../assets/vehicle-placeholder.png';
import { partnerBadgeAssets } from './constants/partnerBadgeAssets';
import { ApplicationCardProps } from './types/ApplicationCardProps';

export const ApplicationCard = ({
  applicationDescription,
  brand,
  defaultImage,
  description,
  id,
  testId,
}: ApplicationCardProps): ReactNode => {
  const [imageFailedToLoad, setImageFailedToLoad] = useState(false);

  return (
    <li data-testid={testId}>
      <Card
        className="application-card"
        component={Link}
        raised={false}
        to={`/dashboard/application/${id}`}
      >
        <figure>
          <CardMedia
            alt={description}
            component={'img'}
            image={
              defaultImage && !imageFailedToLoad
                ? defaultImage
                : VehicleImagePlaceholder
            }
            onError={(): void => {
              setImageFailedToLoad(true);
            }}
          />
          {brand && (
            <img
              alt={brand}
              className="partner-badge"
              src={partnerBadgeAssets[brand]}
            />
          )}
        </figure>
        <CardContent>
          <p className="card-title">{description}</p>
          <p className="card-subtitle">{applicationDescription}</p>
        </CardContent>
      </Card>
    </li>
  );
};
